import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 6
	render() {
		const style = {
			st146: {
				fill: 'none',
			},
			st119: {
				opacity: 0.5,
			},
			st2: {
				fill: '#FFFFFF',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} style={style.st146} cx="61.3626823" cy="19.4572811" />
				<g style={style.st119}>
					<path style={style.st2} d="M121.953125,2.6815338c-0.6191406-0.9355469-1.6503906-1.5166016-2.7714844-1.5634766
						L94.0996094,0.0765533c-0.0488281-0.0019531-0.0966797-0.0029297-0.1455078-0.0029297
						c-6.1728516,0-10.9902344,0.7036133-14.7021484,1.6772461c-0.0400391,0.0097656-0.0800781,0.0205078-0.1201172,0.0317383
						c-5.1025391,1.3552246-8.0871582,3.0380859-9.6259766,4.2619629C67.3393555,4.8192291,64.762207,3.9486237,62,3.9486237h-1
						c-2.762207,0-5.3393555,0.8706055-7.5058594,2.0959473c-1.5388184-1.223877-4.5234375-2.9957275-9.6259766-4.3509521
						c-0.0400391-0.0112305-0.0800781,0.022522-0.1201172,0.0127563c-3.7119141-0.9736328-8.5302734-1.6549988-14.7021484-1.6549988
						c-0.0488281,0-0.0966797,0.0121002-0.1455078,0.0140533L3.8183594,1.1124954
						C2.6972656,1.1593704,1.6660156,1.743206,1.046875,2.6787529C0.4267578,3.6142998,0.2929688,4.7919598,0.6865234,5.842741
						l2,5.3341913c0.0478516,0.1271973,0.1066895,0.248394,0.1679688,0.3672915
						c0.1237793,1.2011719,0.2268066,2.4481716,0.3300781,3.7328396
						c0.9335938,11.6308594,2.3457031,29.2076054,25.5673828,29.5039921
						c0.2255859,0.0029297,0.4482422,0.0044403,0.6708984,0.0044403c8.421875,0,14.5986328-2.074688,18.8662109-6.3329887
						c6.4001465-6.3867188,6.6088867-15.870594,6.5395508-23.7890511l0.0766602-0.6262159
						C55.9970703,12.2511082,58.2944336,10.9486237,61,10.9486237h1c2.7055664,0,5.0029297,1.3024902,6.0947266,3.088623
						l0.0766602,0.5372314c-0.0673828,7.78125,0.1411133,17.2261353,6.4008789,23.5908813
						c4.3535156,4.4262695,10.7685547,6.7832642,19.6103516,6.7832642c0.0888672,0,0.1767578,0,0.265625,0
						c22.6425781,0,24.1884766-17.2521973,25.2119141-28.6276855c0.1474609-1.6467285,0.2919922-3.2410889,0.4765625-4.7147217
						c0.0649414-0.1252441,0.1264648-0.2734985,0.1767578-0.4077759l2-5.3439026
						C122.7070312,4.8037567,122.5732422,3.6170807,121.953125,2.6815338z M43.4545898,33.4974518
						c-2.9345703,2.9291992-7.8654785,4.3696289-14.5578613,4.284668
						c-15.671875-0.2006836-17.5987549-9.2626953-18.7071533-23.0654297
						c-0.1088867-1.3579102-0.2324829-2.6760254-0.3638306-3.9443359c1.1499023-1.2155762,3.2846375-3.0004883,6.0522156-3.1254883
						c0.1318359-0.0058594,0.2582855-0.019043,0.3852386-0.0395508l12.8557053-0.5336914
						c5.6845703,0.0053711,10.0474815,0.6694336,13.15588,1.5068359c3.708252,1.1955566,4.7623253,4.9990234,5.7623253,6.1918945
						v3.6987305C48.0371094,24.2025299,47.0522461,29.9071198,43.4545898,33.4974518z M94.4677734,37.9486237
						c-0.0810547,0-0.1621094,0-0.2441406,0c-6.8847656,0-11.7524414-1.6166992-14.7338867-4.6474609
						c-3.5214844-3.5810547-4.4526367-9.2783203-4.4526367-14.9086914v-3.6162109
						c1-1.2133789,2.0153809-4.9709473,5.6782227-6.1801758c3.1152344-0.8466797,7.4191895-1.5170898,13.1311035-1.5224609
						l12.8756104,0.5336914c0.1269531,0.0205078,0.2659302,0.0336914,0.3977661,0.0395508
						c2.7663574,0.125,4.9117737,1.9082031,6.0585022,3.1181641c-0.1940918,1.5683594-0.3409882,3.244873-0.4921112,4.9287109
						C111.4459686,29.4754791,109.5976562,37.9486237,94.4677734,37.9486237z" />
				</g>
				<path style={style.st2} d="M8.4638672,7.1986237h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3
					c0.828125,0,1.5,0.6713867,1.5,1.5S9.2919922,7.1986237,8.4638672,7.1986237z" />
				<path style={style.st2} d="M117.5361328,7.1986237h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3
					c0.828125,0,1.5,0.6713867,1.5,1.5S118.3642578,7.1986237,117.5361328,7.1986237z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 6
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="32.276268" cy="10.2851295" />
				<g opacity="0.5">
					<path fill="#FFFFFF" d="M64.3892059,1.3939835c-0.3281479-0.4958399-0.8747101-0.8037989-1.4688911-0.8286426
						L49.6268387,0.0133438c-0.0258789-0.0010352-0.051239-0.0015527-0.0771179-0.0015527
						c-3.2716103,0-5.8248253,0.372915-7.792141,0.8889405c-0.0212173,0.0051758-0.0424385,0.0108691-0.0636597,0.0168213
						c-2.7043457,0.7182691-4.2861938,1.6101856-5.1017685,2.2588403c-1.1482468-0.649431-2.5141373-1.110852-3.9781036-1.110852
						h-0.5300026c-1.4639683,0-2.8298569,0.461421-3.9781036,1.110852c-0.8155746-0.6486547-2.3974228-1.5877355-5.1017685-2.3060045
						c-0.0212212-0.0059522-0.0424404,0.0119366-0.0636616,0.0067608C20.973196,0.3611239,18.419466,0,15.1483727,0
						c-0.0258789,0-0.05124,0.0064131-0.0771189,0.0074483L1.777777,0.5623931
						C1.1835972,0.5872369,0.6370347,0.8966697,0.3088902,1.3925096c-0.3286621,0.4958398-0.3995703,1.1199995-0.1909863,1.6769136
						l1.0600001,2.8271213C1.2032652,5.9639592,1.2344493,6.028194,1.2669274,6.0912089
						c0.065603,0.636621,0.1202074,1.2975311,0.1749413,1.9784055c0.4948047,6.1643553,1.2432226,15.4800301,13.5507126,15.6371155
						c0.1195612,0.0015526,0.2375689,0.0023518,0.3555765,0.0023518c4.4635944,0,7.7372761-1.0995827,9.9990921-3.3564816
						c3.3920765-3.3849621,3.5027103-8.4114151,3.4659615-12.6081982l0.0406303-0.3318939
						c0.5786514-0.9466505,1.7962551-1.6369672,3.2302036-1.6369672h0.5300026c1.4339485,0,2.6515503,0.6903195,3.2302017,1.63697
						l0.0406303,0.2847328c-0.0357132,4.1240621,0.074791,9.1298504,3.3924675,12.5031662
						c2.3073616,2.3459225,5.7073326,3.5951309,10.393486,3.5951309c0.0471001,0,0.0936813,0,0.1407814,0
						c12.0005646,0,12.8198929-9.1436653,13.3623161-15.1726742c0.0781517-0.872766,0.1547546-1.7177768,0.2525749-2.4988022
						c0.03442-0.0663795,0.067028-0.1449542,0.0936813-0.2161212l1.0600052-2.8322685
						C64.7887726,2.5187616,64.717865,1.8898233,64.3892059,1.3939835z M22.7849789,17.7264194
						c-1.5553226,1.5524769-4.1687031,2.3159046-7.7156668,2.270874c-8.3060932-0.1063614-9.3273392-4.9092283-9.9147911-12.2246771
						c-0.0577102-0.7196927-0.1232162-1.4182935-0.1928306-2.090498c0.6094484-0.6442556,1.7408581-1.5902591,3.207674-1.6565089
						c0.0698738-0.0031056,0.1368914-0.0100927,0.2041769-0.0209618l6.8135242-0.2828567
						c3.0128222,0.0028467,5.3251638,0.3548,6.9726152,0.7986233c1.965374,0.6336446,2.5240326,2.6494823,3.0540333,3.2817039
						v1.9603271C25.2137146,12.8001118,24.6917362,15.8235435,22.7849789,17.7264194z M49.8219681,20.0855408
						c-0.0429611,0-0.0859184,0-0.1293945,0c-3.6489258,0-6.2287941-0.8568497-7.80896-2.4631538
						c-1.8663902-1.8979588-2.3598976-4.91751-2.3598976-7.9016066V7.8041887
						c0.5299988-0.6430912,1.0681496-2.6346021,3.0094566-3.2754931c1.6510735-0.4487405,3.9321709-0.8040578,6.9594841-0.8069046
						l6.8240738,0.2828567c0.0672836,0.010869,0.1409416,0.0178561,0.2108154,0.0209618
						c1.4661713,0.0662498,2.603241,1.0113478,3.2110062,1.652627c-0.1028671,0.8312302-0.1807213,1.7197828-0.2608185,2.6122165
						C58.8204117,15.5947742,57.8408051,20.0855408,49.8219681,20.0855408z" />
				</g>
				<path fill="#FFFFFF" d="M4.2398958,3.7880411H2.6498961c-0.4389064,0-0.7950001-0.355835-0.7950001-0.7950001
					S2.2109897,2.198041,2.6498961,2.198041h1.5899997c0.4389067,0,0.7950001,0.355835,0.7950001,0.7950001
					S4.6788025,3.7880411,4.2398958,3.7880411z" />
				<path fill="#FFFFFF" d="M62.0481987,3.7880411h-1.5900002c-0.4389076,0-0.795002-0.355835-0.795002-0.7950001
					s0.3560944-0.7950001,0.795002-0.7950001h1.5900002c0.4389038,0,0.7949982,0.355835,0.7949982,0.7950001
					S62.4871025,3.7880411,62.0481987,3.7880411z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 6
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} fill="none" cx="42.62904" cy="13.58413" />
				<g opacity="0.5">
					<path fill="#FFFFFF" d="M85.04234,1.84111c-0.4334-0.65488-1.15527-1.06162-1.94004-1.09443L65.54488,0.01762
						c-0.03418-0.00137-0.06768-0.00205-0.10186-0.00205c-4.32099,0-7.69316,0.49253-10.2915,1.17407
						C55.1235,1.19648,55.09547,1.204,55.06744,1.21186c-3.57178,0.94866-5.66101,2.12666-6.73818,2.98337
						c-1.51655-0.85774-3.32056-1.46716-5.2541-1.46716h-0.7c-1.93354,0-3.73755,0.60942-5.2541,1.46716
						c-1.07718-0.85671-3.16641-2.09701-6.73819-3.04567c-0.02803-0.00786-0.05605,0.01577-0.08408,0.00893
						C27.70045,0.47696,24.3276,0,20.00728,0c-0.03418,0-0.06767,0.00847-0.10185,0.00984L2.34801,0.74278
						C1.56324,0.7756,0.84137,1.18428,0.40797,1.83916c-0.43408,0.65488-0.52773,1.47924-0.25225,2.21479l1.4,3.73393
						c0.0335,0.08904,0.07468,0.17388,0.11758,0.2571c0.08665,0.84082,0.15876,1.71372,0.23105,2.61299
						c0.65352,8.1416,1.64199,20.44532,17.89717,20.65279c0.15791,0.00205,0.31377,0.00311,0.46963,0.00311
						c5.89531,0,10.21904-1.45228,13.20635-4.43309c4.4801-4.4707,4.62622-11.10942,4.57768-16.65234l0.05367-0.43835
						c0.76426-1.25029,2.37241-2.16203,4.26631-2.16203h0.7c1.89389,0,3.50205,0.91174,4.26631,2.16204l0.05366,0.37606
						c-0.04717,5.44688,0.09878,12.0583,4.48061,16.51362c3.04746,3.09839,7.53799,4.74829,13.72725,4.74829
						c0.0622,0,0.12373,0,0.18594,0c15.84981,0,16.93193-12.07654,17.64834-20.03938c0.10323-1.15271,0.2044-2.26876,0.3336-3.3003
						c0.04546-0.08767,0.08852-0.19145,0.12373-0.28544l1.39999-3.74073C85.57008,3.32667,85.47643,2.49599,85.04234,1.84111z
						 M30.09337,23.41225c-2.0542,2.05044-5.50583,3.05874-10.1905,2.99927C8.93255,26.27104,7.58374,19.92763,6.80786,10.26572
						C6.73164,9.31518,6.64512,8.3925,6.55318,7.50468c0.80493-0.8509,2.29925-2.10034,4.23655-2.18784
						c0.09229-0.0041,0.1808-0.01333,0.26967-0.02769l8.99899-0.37358c3.9792,0.00376,7.03324,0.4686,9.20912,1.05479
						c2.59578,0.83689,3.33363,3.49932,4.03363,4.33433v2.58911C33.30113,16.90581,32.61173,20.89902,30.09337,23.41225z
						 M65.8026,26.52807c-0.05674,0-0.11348,0-0.1709,0c-4.81934,0-8.22671-1.13169-10.31372-3.25322
						c-2.46504-2.50674-3.11684-6.49483-3.11684-10.43608v-2.53135c0.7-0.84937,1.41077-3.47966,3.97475-4.32612
						c2.18066-0.59268,5.19343-1.06196,9.19177-1.06572l9.01292,0.37358c0.08887,0.01436,0.18616,0.02358,0.27844,0.02769
						c1.93645,0.0875,3.43824,1.33574,4.24095,2.18271c-0.13586,1.09785-0.23869,2.27141-0.34448,3.4501
						C77.68733,20.59687,76.39352,26.52807,65.8026,26.52807z" />
				</g>
				<path fill="#FFFFFF" d="M5.59986,5.00307h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1
					c0.57969,0,1.05,0.46997,1.05,1.05S6.17955,5.00307,5.59986,5.00307z" />
				<path fill="#FFFFFF" d="M81.95045,5.00307h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1
					c0.57969,0,1.05,0.46997,1.05,1.05S82.53014,5.00307,81.95045,5.00307z" />
			</g>
		);
	}
}


function Kerry(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisKerry = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisKerry)) {
		return null;
	}

	return <ThisKerry {...props} />;
}

export default Kerry;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Kerry.js